import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import State from "../../../../../../context";
import dayjs from "dayjs";
import ModalLevelProductDetails from "../../component/ModalLevelProductDetails";
import TemplatePageDashboard from "./template";
import quarterOfYear from "dayjs/plugin/quarterOfYear";

dayjs.extend(quarterOfYear);

import { ANALYTIC_START_PERIOD_BX } from "../../../../../bx/constant";

import { getAnalyticCalculation } from "./helper";
import { addAdminAnalytic } from "../../../../../../utils/request/manager";
import { isOrganizationBx } from "../../../../../../utils/helper/specialized";

const PageDashboard = () => {
  const [state] = useContext(State);
  const navigate = useNavigate();

  const currentQuarter = dayjs().quarter();
  const currentYear = +dayjs().format("YYYY");
  const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
  const lastQuarterYear = currentQuarter === 1 ? currentYear - 1 : currentYear;

  const analyticLastQuarter = state.analytics?.find(
    it => it.quarter === lastQuarter && it.year === lastQuarterYear
  );

  useEffect(() => {
    if (state.loading || state.showOverlay) return;

    if (isOrganizationBx(state.organization?.name)) {
      // do not add last quarter analytic for before registration company period
      if (
        ANALYTIC_START_PERIOD_BX.year === lastQuarterYear &&
        ANALYTIC_START_PERIOD_BX.quarter === lastQuarter
      )
        return;
    }

    if (!analyticLastQuarter) {
      const requestPayload = [
        ...(state.analytics ?? []),
        {
          quarter: lastQuarter,
          year: lastQuarterYear,
          pointAdded: new Date(),
          ...getAnalyticCalculation({
            managedUserManagers: state.managedUserManagers,
            productsList: state.productsList,
            searchQuarter: lastQuarter,
            searchYear: lastQuarterYear,
          }),
        },
      ];

      // save last quarter analytic, when new quarter start
      addAdminAnalytic({
        managerEmail: state._id,
        requestPayload,
      })
        .then(() => state.setUserData())
        .catch(state.showError);
    }
  }, [state]);

  const onClickViewAllProposals = () => {
    navigate(
      `/wealth-admin-portal/proposals?email=${encodeURIComponent(state._id)}`
    );
  };

  const onClickProductDetails = productDetailsId => {
    state.setKeyValue("productDetailsId", productDetailsId);
    state.setKeyValue("openModalProductDetails", true);
  };

  const onClickViewProposal = activeEmail => {
    state.setKeyValue("activeEmail", activeEmail);
    state.setKeyValue("activeTabPagePeople", "clientsLeads");
    state.setKeyValue("activeSection", "client");
    navigate(
      `/wealth-admin-portal/people?email=${encodeURIComponent(state._id)}`
    );
  };

  return (
    <>
      <TemplatePageDashboard
        analytics={state.analytics}
        managedUserManagers={state.managedUserManagers}
        onClickProductDetails={onClickProductDetails}
        onClickViewAllProposals={onClickViewAllProposals}
        onClickViewProposal={onClickViewProposal}
        personalInfo={state.personalInfo}
        productsList={state.productsList}
      />

      <ModalLevelProductDetails
        handleClose={() => state.setKeyValue("openModalProductDetails", false)}
        investmentAssumptions={state.investmentAssumptions}
        open={state.openModalProductDetails}
        product={state.productsList?.find(
          it => it._id === state.productDetailsId
        )}
        showError={state.showError}
      />
    </>
  );
};

export default PageDashboard;
